import Panel from "@magicware/dashboard/Panel";
import { buildForm } from "@magicware/forms/builder";
import Form, { FormImplementationProps } from "@magicware/forms/components/Form";
import FormGrid from "@magicware/forms/components/FormGrid";
import FormTextField from "@magicware/forms/mui/FormTextField";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { updateDetail } from "../../redux/connectors/connectorsReducer";
import { ConnectorModelDetail } from "../../services/api/connectors";
import { FormBrandsAutocomplete } from "../brands/FormBrandsAutocomplete";

export const connectorForm = buildForm<ConnectorModelDetail>()(() => ({
    props: {
        remove: ["id", "version"],
        extra: [],
    },
    transformations: {
        toForm: { fromModel: (h, m: ConnectorModelDetail) => h.fromModel(m) },
        formTo: {
            new: (h, f) => h.toNewEntity(f),
            update: (h, f, m: ConnectorModelDetail) => h.toUpdateEntity(f, m),
        },
    },
    updateReduxModel: updateDetail,
    schema: (_, t) => ({
        name: yup.string().required(t("name-is-required")),
        brand: yup.object().required(t("brand-is-required")),
        form: yup.string(),
        notes: yup.string(),
    }),
}));

const f = connectorForm.f;

export default function ConnectorForm(props: FormImplementationProps<typeof f>) {
    const { t } = useTranslation();
    return (
        <Form validationSchema={connectorForm.validationSchema} {...props}>
            <Panel>
                <FormGrid>
                    <FormTextField f={f} field="name" label={t("name-label")} autoFocus={props.autoFocus} />
                    <FormTextField f={f} field="form" label={t("form-label")} autoFocus={props.autoFocus} />
                    <FormBrandsAutocomplete f={f} field="brand" fullOption label={t("brand-label")} filter={{}} />
                    <FormTextField f={f} field="notes" label={t("notes-label")} multiline />
                </FormGrid>
            </Panel>
        </Form>
    );
}
